"use client";

import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionTrigger,
} from "@tillix/ui-atoms/atoms/accordion";
import { ExternalLink, FileText } from "lucide-react";
import { useT } from "@/features/i18n/hooks/use-t";
import { aboutUsSections, externalLinks, hardshipLinks } from "./aboutUsData";

export default function AboutUsContent() {
  const { t } = useT();

  return (
    <div className="w-full pb-10 sm:pb-0">
      <Accordion defaultValue={[aboutUsSections[0].id]} multiple={true}>
        {aboutUsSections.map((section) => (
          <AccordionItem key={section.id} value={section.id}>
            <AccordionTrigger className="text-left hover:no-underline">
              {t(section.titleKey)}
            </AccordionTrigger>
            <AccordionPanel>
              <div className="space-y-3">
                {section.paragraphKeys.map((key) => (
                  <p
                    className="text-muted-foreground leading-relaxed"
                    key={key}
                  >
                    {t(key)}
                  </p>
                ))}
              </div>

              {section.id === "bay-restoration" && (
                <div className="mt-3">
                  {externalLinks.map((link) => (
                    <a
                      className="inline-flex items-center gap-1.5 text-sm text-tenant-howard-county-primary-primary-blue hover:underline"
                      href={link.href}
                      key={link.href}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <ExternalLink className="h-3.5 w-3.5" />
                      {t(link.labelKey)}
                    </a>
                  ))}
                </div>
              )}

              {section.id === "hardship" && (
                <div className="mt-3 flex flex-col gap-1.5">
                  {hardshipLinks.map((link) => (
                    <a
                      className="inline-flex items-center gap-1.5 text-sm text-tenant-howard-county-primary-primary-blue hover:underline"
                      href={link.href}
                      key={link.href}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <FileText className="h-3.5 w-3.5 shrink-0" />
                      {t(link.labelKey)}
                    </a>
                  ))}
                </div>
              )}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
